import { withFormik } from 'formik';
import isFunction from 'lodash/isFunction';

/**
 * Enhanced the withFormik higher order component with initial validation logic
 * @param {Object} props Any props that you want to pass to withFormik (validationSchema is required)
 * @return {Function} an enhanced withFormik with initialValidation
 */
export const formikWithInitialValidation = props =>
  withFormik({
    ...props,
    isInitialValid({ initialValues, data }) {
      const validationSchema = isFunction(props.validationSchema)
        ? props.validationSchema({ data, initialValues })
        : props.validationSchema;

      return validationSchema.isValidSync(initialValues);
    },
  });
